import AddressApiDataGouvDto from './AddressApiDataGouvDto'

export default class ContactDto {
    constructor(obj) {
        this.address = new AddressApiDataGouvDto(obj.address)
        this.cityCode = obj.cityCode
    }
}